<div class="row row-header">
  <div class="col-md-11 col-sm-11">
    <h1 mat-dialog-title class="text-center ml115">Parameter Details</h1>
  </div>
  <div class="col-md-1 col-sm-1 nopadding">
    <a class="cancelBtn cancelBtnPos" (click)="onCancelClick()"></a>
  </div>
</div>
<div mat-dialog-content>
  <div class="row px-5 py-4 no-overflow">
    <div class="col-sm-12 pad-lr">
      <div class="row mb-2" *ngFor="let item of data[0] | keyvalue">
        <div class="col-sm-4">
          <label [for]="item.key" class="form-label"><strong>{{item.key}}:</strong></label>
        </div>
        <div class="col-sm-8">
          <label [for]="item.value" class="form-label">{{item.value}}</label>
        </div>
      </div>
    </div>
  </div>
</div>




